export const NORMAL_COLOR_VALUE = '#84B909';
export const MODERATE_COLOR_VALUE = '#FF7417';
export const ESCALATED_COLOR_VALUE = '#FF0000';
export const DEFAULT_BAR_CAR = '#4666FF';
export const SOA_C2M_ALERT_IDS = [7, 8];

export const TIME_RANGE: Record<string, timeType> = {
  15: 15,
  30: 30,
  60: 60
} as const;

export type timeType = 15 | 30 | 60;
